import { Campaign } from '@/models/campaign.model'
import { api } from '@/services/api'

type FetchManyByCampaignIdsParams = {
  campaignIds: string[]
  ownerId: string
}

export type FetchManyByCampaignIdsResponse = {
  campaigns: Campaign[]
}

export async function fetchManyByCampaignIds(params: FetchManyByCampaignIdsParams) {
  const response = await api.get<FetchManyByCampaignIdsResponse>(`/campaigns/find-by-campaign-ids`, {
    params
  })
  return response.data
}

type FetchCampaignByIdParams = {
  campaignId: string
}

export type FetchCampaignByIdResponse = {
  campaign: Campaign
}

export async function fetchCampaignById(params: FetchCampaignByIdParams) {
  const response = await api.get<FetchCampaignByIdResponse>(`/campaigns/${params.campaignId}`, {
    params
  })
  return response.data
}
